import api from './api';

export const getHelpByField = async (params) => {
  const formName = params[0];
  const fieldName = params[1];
  const response = await api.get(`/help/${formName}/${fieldName}`);
  return response.data;
};
 
